import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
declare var $ :any

@Component({
    selector: 'app-vote',
    templateUrl: './vote.component.html',
    styleUrls: ['./vote.component.scss'],
    standalone: false
})
export class VoteComponent implements OnInit, OnDestroy {

  @Input() count: number = 0
  @Input() currentItem: number = 0
  @Input() mediaType: string = ''
  @Input() underPlay: boolean = false
  @Input() showVote: boolean = false
  @Output() makeVote = new EventEmitter<{voted: boolean, votedPreValue: number, votedValue: number}>()
  @Output() makeSubmitVote = new EventEmitter<{votedValue: number}>()

  voted: boolean = false
  votedValue: number = 0
  showAllTime: boolean = false
  votedPreValue: number = 0
  offsetLeft: number = 0
  offsetWidth: number = 0
  fromKeyboard: boolean = false
  showInstructions: boolean = false
  pointerStyle = {
    'display': 'none',
    'left': '0%'
  }

  qpListener = null

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.qpListener = this.route.queryParams.subscribe((queryParams) => {
      if (queryParams.showAllTime) {
        this.showAllTime = queryParams.showAllTime === 'true'
      }
    })
  }

  ngOnDestroy(): void {
    this.qpListener.unsubscribe()
  }

  onFocus() {
    if (this.fromKeyboard) {
      this.showInstructions = true
      this.pointerStyle = {
        'display': 'block',
        'left': '48%'
      }
    } else {
      this.showInstructions = false
    }
  }

  onBlur() {
    this.showInstructions = false
  }

  onVote(event: MouseEvent) {
    this.coordinates(event)
    const offsetWidth = $('.voting-container .interval-group').width()
    const value = this.votedPreValue
    this.voted = true
    this.makeVote.emit({
      voted: true,
      votedPreValue: this.votedPreValue,
      votedValue: value
    })
  }

  onSubmitVote() {
    const offsetWidth = $('.voting-container .interval-group').width()
    const value = this.votedPreValue
    this.pointerStyle = {
      'display': 'none',
      'left': '0%'
    }

    this.voted = false

    this.makeSubmitVote.emit({
      votedValue: this.votedPreValue
    })
  }

  private coordinates(event: MouseEvent):void {
    const poiWidth = 12
    this.offsetLeft = $('.voting-container.' + this.mediaType).offset().left
    this.offsetWidth = $('.voting-container .interval-group.' + this.mediaType).width()

    const newLeft = ((event.clientX - this.offsetLeft - poiWidth) / this.offsetWidth) * 100
    const minLeft = this.offsetLeft + poiWidth
    const maxLeft = this.offsetLeft + this.offsetWidth - poiWidth
    if (this.voted === false && event.clientX >= minLeft && event.clientX <= maxLeft && newLeft <= 100 && newLeft >= 0 ) {
      this.votedPreValue = newLeft
      this.pointerStyle = {
        'display': 'block',
        'left': this.votedPreValue + '%'
      }
    }
   }

   keypress(event) {

    if (event.key == 'Enter') {
      const value = this.votedPreValue
      this.voted = true
      this.makeVote.emit({
        voted: true,
        votedPreValue: this.votedPreValue,
        votedValue: value
      })
      return false
    }

     if (event.key === 'Tab') {
       this.fromKeyboard = true
       this.onFocus()
       return false
     }

     this.offsetLeft = $('.voting-container.' + this.mediaType).offset().left
     this.offsetWidth = $('.voting-container .interval-group.' + this.mediaType).width()

     const minLeft = this.offsetLeft - 16
     const maxLeft = this.offsetLeft + this.offsetWidth - 12

    const poi = document.getElementById('selector')

    const poiRect = poi.getBoundingClientRect()

    const currentLeft = poiRect.left

    let newLeft

     if ( event.key === 'ArrowLeft' ) { newLeft = currentLeft - 10 }

     if ( event.key === 'ArrowRight' ) { newLeft = currentLeft + 10 }

     const newLeftPercent = ((newLeft - this.offsetLeft) / this.offsetWidth) * 100

     console.log(newLeftPercent)

     if (this.voted === false && newLeft >= minLeft && newLeft <= maxLeft && newLeftPercent <= 100 && newLeftPercent >= 0 ) {
       this.votedPreValue = newLeftPercent
       this.pointerStyle = {
         'display': 'block',
         'left': this.votedPreValue + '%'
       }
     }
   }
}
